"use client";

import { c as _c } from "react/compiler-runtime";
import { useSearchParams } from "next/navigation";
import { Suspense, useOptimistic } from "react";
import { useTranslations } from "@/i18n/client";
import { cn } from "@/lib/utils";
import { AddToCartButton } from "@/ui/storefront/AddToCartButton";
import { findSelectedVariant } from "@/ui/yns-components/components/product-details/find-selected-variant";
import { ProductVariantSelector } from "@/ui/yns-components/components/product-details/product-variant-selector";
// Made this a client component to use `useOptimistic`
// to speed up enabling the "Add to cart" button after selecting a variant
export const ProductDetailsInner = t0 => {
  const $ = _c(28);
  const {
    product,
    theme,
    domain
  } = t0;
  const searchParams_ = Object.fromEntries(useSearchParams().entries());
  const [optimisticSearchParams, setOptimisticSearchParams] = useOptimistic(searchParams_, _temp);
  let t1;
  if ($[0] !== optimisticSearchParams || $[1] !== product.variants) {
    t1 = findSelectedVariant(product.variants, optimisticSearchParams);
    $[0] = optimisticSearchParams;
    $[1] = product.variants;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const selectedVariant = t1;
  const selectedSubscription = optimisticSearchParams.subscription_ === product.subscription?.id ? product.subscription : null;
  const t = useTranslations("/product.page");
  let t2;
  if ($[3] !== product.variants) {
    t2 = product.variants.flatMap(_temp2);
    $[3] = product.variants;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const combinationsCount = t2.length;
  let t3;
  if ($[5] !== combinationsCount || $[6] !== optimisticSearchParams || $[7] !== product.subscription || $[8] !== product.variants || $[9] !== setOptimisticSearchParams || $[10] !== t) {
    t3 = (combinationsCount > 0 || product.subscription) && <div className="grid gap-2"><p className="sr-only" id="variant-label">{t("variantTitle")}</p><Suspense><ProductVariantSelector subscription={product.subscription} variants={product.variants} optimisticSearchParams={optimisticSearchParams} setOptimisticSearchParams={setOptimisticSearchParams} /></Suspense></div>;
    $[5] = combinationsCount;
    $[6] = optimisticSearchParams;
    $[7] = product.subscription;
    $[8] = product.variants;
    $[9] = setOptimisticSearchParams;
    $[10] = t;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const t4 = theme.buttonTextColor ?? undefined;
  const t5 = theme.buttonBackgroundColor ?? undefined;
  const t6 = theme.buttonHoverBackgroundColor ?? undefined;
  const t7 = theme.priceColor ?? undefined;
  let t8;
  if ($[12] !== t4 || $[13] !== t5 || $[14] !== t6 || $[15] !== t7) {
    t8 = {
      "--theme-product-details-add-to-cart-button-color": t4,
      "--theme-product-details-add-to-cart-button-background-color": t5,
      "--theme-product-details-add-to-cart-button-hover-background-color": t6,
      "--theme-product-details-price-color": t7
    };
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = cn("text-[var(--theme-product-details-add-to-cart-button-color,#fff)]", "bg-[var(--theme-product-details-add-to-cart-button-background-color,#000)]", "hover:bg-[var(--theme-product-details-add-to-cart-button-hover-background-color,#222)]");
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  const t10 = selectedSubscription || null;
  const t11 = !selectedVariant || (typeof selectedVariant?.stock === "number" ? selectedVariant.stock <= 0 : false);
  let t12;
  if ($[18] !== domain || $[19] !== product || $[20] !== selectedVariant || $[21] !== t10 || $[22] !== t11 || $[23] !== t8) {
    t12 = <AddToCartButton style={t8} className={t9} variant={selectedVariant} subscription={t10} product={product} domain={domain} disabled={t11} />;
    $[18] = domain;
    $[19] = product;
    $[20] = selectedVariant;
    $[21] = t10;
    $[22] = t11;
    $[23] = t8;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t12 || $[26] !== t3) {
    t13 = <>{t3}{t12}</>;
    $[25] = t12;
    $[26] = t3;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  return t13;
};
function _temp(state, action) {
  return action ?? state;
}
function _temp2(c) {
  return c.combinations;
}